import { fetchArticle } from '@elevio/kb-kit/lib/api/article';
import { Categories } from '@elevio/kb-kit/lib/components';
import { useCategories } from '@elevio/kb-kit/lib/hooks';
import { useEffect, useState } from 'react';
import { getAssetURL } from '@elevio/kb-kit/lib/utils/globals';
import ArticleList from '../components/ArticleList';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HomeArticles from '../components/HomeArticles';
import { MainSection } from '../components/layouts/Main';
import PageLayout from '../components/layouts/Page';
import Breadcrumb from '../components/PageBreadcrumbs';
import { homeArticleIds } from '../utils/constants';
import { fetchAgencyFlags } from '../requests/agency-flags';
import { privateSubmissionUrl } from '../utils/privateSubmissionUrl';
export const getHeader = () => {
    return (<Header hideSearch breadcrumbs={<div className="breadcrumbs-header-wrapper">
          <Breadcrumb className="breadcrumbs-header"/>
        </div>}>
      <div className="header-container"/>
    </Header>);
};
const openPrivateSubmission = (path) => {
    const url = privateSubmissionUrl(path);
    if (!url) {
        return;
    }
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
        newWindow.opener = null;
    }
};
const AGENCY_ID = 207;
const HomePage = () => {
    useCategories();
    const [articles, setArticles] = useState([]);
    const [showViewAllRequests, setShowViewAllRequests] = useState(false);
    useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const responses = await Promise.all(homeArticleIds.map((id) => fetchArticle(id, '1')));
                setArticles(responses);
            }
            catch (error) {
                console.error('Error fetching articles:', error);
            }
        };
        fetchArticles();
    }, []);
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('create');
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('listing');
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('public-map');
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        <h1 className="sr-only">City of Grand Prairie Code Compliance</h1>
        <section className="button-container button-container--three">
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleSubmitRequest}>
              <img src={getAssetURL('images/request.svg')} alt="" aria-hidden/>
              Submit a Request
            </button>
          </div>
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewMyRequests}>
              <img src={getAssetURL('images/inbox.svg')} alt="" aria-hidden/>
              View My Requests
            </button>
          </div>
          {showViewAllRequests ? (<div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleViewAllRequests}>
                <img src={getAssetURL('images/map.svg')} alt="" aria-hidden/>
                View All Requests
              </button>
            </div>) : null}
        </section>
        <section className="article-container">
          <div className="view-requests-section">
            <HomeArticles articles={articles}/>
          </div>
          <div className="view-requests-section">
            <Categories.Loop limit={1}>
              <ArticleList />
            </Categories.Loop>
          </div>
        </section>
      </MainSection>
    </PageLayout>);
};
export default HomePage;
